module.exports = __webpack_public_path__ + "static/media/euro_icon.7490ad74.svg";